import classNames from 'classnames';
import React from 'react';

export interface RCEyebrowProps {
  /** The label of the Eyebrow - Should be kept to 1-2 words only */
  text: string;

  /** `highlight` should used for Bump, `alert` for Price Drop-like things, and `default` for anything else. */
  type?: 'default' | 'highlight' | 'alert';

  /** Set to `true` if the eyebrow is rendering on a dark background */
  inverted?: boolean;

  /** Set to `true` if eyebrow text should be truncated to a single line */
  truncate?: boolean;
}

export function RCEyebrow({
  text,
  type = 'default',
  inverted = false,
  truncate = false,
}: RCEyebrowProps) {
  return (
    <div className={classNames(
      'rc-eyebrow',
      {
        'rc-eyebrow--highlight': type === 'highlight',
        'rc-eyebrow--alert': type === 'alert',
        'rc-eyebrow--inverted': inverted,
        'rc-eyebrow--truncate': truncate,
      },
    )}>
      {text}
    </div>
  );
}
